import React, { useState } from "react";
import { f7, Page, Input, Button, Link, Icon } from "framework7-react";
import axios from 'axios';
import { API_BASE_URL, API_AUTH } from './../globals';
// import logo from '../../src/img/logo/eatbids-sm-logo.png';

const PageChangePassword = () => {
  const [data, setData] = useState([]);

  const handleChangePassword = (e) => {
    e.preventDefault();
    axios.put(API_BASE_URL + 'restforgotpwdupdate/id/'+localStorage.getItem('id'), data,
    {
      headers: {
        'Authorization': 'Basic ' + API_AUTH
      }

    }).then(response => {
      if(response.data.status == "success"){
        localStorage.clear();
          // Navigate to login page
        f7.views.main.router.navigate('/login/')
        f7.toast.create({
          text: 'Password Updated..!',
          position: 'top',
          cssClass: 'bg-color-teal',
          closeTimeout: 3000
        }).open()
      }else{
        f7.dialog.alert('Error updating password!')
      }
    })
  };

  return (
    <Page className='bg-white'>
      <div className="container container-table custom-web">
        <div className="row vertical-center-row col-md-12 col-md-offset-12">
            <header className="section-t-space">
              <div className="custom-container1 container-lg">
                <div className="header-panel">
                  <Link href="#" back><Icon ios="material:keyboard_arrow_left" aurora="material:keyboard_arrow_left" md="material:keyboard_arrow_left" className='theme-dark' backLink="Back" ></Icon></Link>
                  <h2>New Password</h2>
                </div>
              </div>
            </header>      
          <div className="custom-container mt-4 p-2">
            <form className="auth-form mt-5" onSubmit={handleChangePassword}>
              <div className="form-group mt-4">
                <label className="form-label fw-semibold dark-text">Enter New Password</label>
                <div className="d-flex gap-3">
                  <div className="form-input dark-border-gradient">
                    <Input type="password" className="form-control" id="password" required validate onInput={(e) => { setData({...data,  rest_password: e.target.value}); }} placeholder="New Password" />                  
                  </div>
                </div>
              </div>
              <div className="form-group mt-4">
                <label className="form-label fw-semibold dark-text">Enter New Password</label>
                <div className="d-flex gap-3">
                  <div className="form-input dark-border-gradient">
                    <Input type="password" className="form-control" id="password" required validate onInput={(e) => { setData({...data,rest_confirm_password: e.target.value}); }} placeholder="Confirm Password" />                  
                  </div>
                </div>
              </div>
              <Button type="submit" className="btn theme-btn w-100 mt-4" large >Submit</Button>
            </form>        
          </div>
        </div>
      </div>


    {/* <div className="otp-container mt-5">
      <Block>
      <LoginScreenTitle className="mt-5"><img src={logo} alt="eatbids"/></LoginScreenTitle>
      <h4 className='text-center'>Verify Email</h4>
      <p className='text-center'>Code is sent to email</p>
      <form>
        <Row>
        {otp.map((digit, index) => (
          <Col className='display-flex flex-direction-column'>
          <input
            key={index}
            type="tel"
            maxLength={1}
            value={digit}
            placeholder=""
            onChange={(e) => handleInputChange(e, index)}
            onKeyPress={(e) => handleInputKeyPress(e, index)}
            onPaste={(e) => handleInputPaste(e)}
            ref={(ref) => inputRefs.current[index] = ref}
            className='verify-input text-center'
            // className={digit !== '' ? 'filled' : ''}
          />
          </Col>
        ))} 
        </Row>
        </form>
        <p className="text-center mt-5">Didn't recieve code? <a href="/register/">Request again</a></p>
        <Button fill large className="mt-3" onClick={handleOTP}>
          Verify Now
        </Button>
      </Block>
      </div> */}
    </Page>
  );
};

export default PageChangePassword;